import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from '../../../../../appCommon/AuthGuard/auth.guard';
import { MenuItems, Modules, SubMenues } from 'src/app/appCommon/Enums/enum';
import { SharedModule } from '../../../../shared/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import {FormsModule} from '@angular/forms';

import { StandardProcessComponent } from '../standard-process/standard-process/standard-process.component';

import { InpatientComponent } from './components/inpatient/inpatient.component';
import { TriageWalkInComponent } from './components/triage-walk-in/triage-walk-in.component';
import { CardModule } from 'primeng/card';
import { NoteComponent } from './components/ems/note/note.component';
import { EMSComponent } from './components/ems/ems.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {DropdownModule} from 'primeng/dropdown';
import {AccordionModule} from 'primeng/accordion';
import {ColorPickerModule} from 'primeng/colorpicker';
import {CalendarModule} from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import {TabMenuModule} from 'primeng/tabmenu';
import { InputTextModule } from 'primeng/inputtext';
import {PanelModule} from 'primeng/panel';
import {ImageModule} from 'primeng/image';
import {FileUploadModule} from 'primeng/fileupload';
import { FileSizePipe } from 'src/app/appCommon/Pipes/fileSize';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { LineBreakPipe } from 'src/app/appCommon/Pipes/LineBreak';
import { ViewFileUploadComponent } from './components/view-file-upload/view-file-upload.component';



const routes: Routes = [
  { path: '', component: StandardProcessComponent, canActivate: [AuthGuard] ,data: { allowedRoles: [MenuItems.StandardProcess]} },
  { path: SubMenues.EMS, canActivate: [AuthGuard], component: EMSComponent,data: { allowedRoles: [MenuItems.StandardProcess]} }, 
  { path: SubMenues.Inpatient, canActivate: [AuthGuard], component: InpatientComponent, data: { allowedRoles: [MenuItems.StandardProcess]} },
  { path: SubMenues.TriageWalkIn, canActivate: [AuthGuard], component: TriageWalkInComponent, data: { allowedRoles: [MenuItems.StandardProcess]} },
];

@NgModule({
  declarations: [StandardProcessComponent, EMSComponent, InpatientComponent, TriageWalkInComponent, NoteComponent,FileSizePipe, FileUploadComponent,LineBreakPipe, ViewFileUploadComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    HttpClientModule,
    SharedModule,
    CardModule,
    DialogModule,
    ButtonModule,
    RadioButtonModule,
    InputTextareaModule,
    DropdownModule,
    FormsModule,
    AccordionModule,
    ColorPickerModule,
    CalendarModule,
    CheckboxModule,
    ToastModule,
    TableModule,
    TabMenuModule,
    InputTextModule,
    PanelModule,
    ImageModule,
    FileUploadModule,
  ],
  providers: [AuthGuard],
})

export class StandardProcessModule { }
